(() => {
  if (window.__sizeGuideModalReady) return;
  window.__sizeGuideModalReady = true;

  // Remembers where a re-parented dialog came from so it can be restored on close.
  const originalPosition = new WeakMap();

  const openModal = (modal) => {
    if (!modal) return;

    // A <dialog> nested inside another already-open <dialog> (e.g. the
    // quick-add modal) fails to render when shown via showModal(): it
    // successfully becomes modal (and blocks the rest of the page) but
    // computes display: none, leaving it invisible and unclickable.
    // Moving it to <body> first avoids the nested-dialog rendering bug;
    // it's moved back to its original spot once closed.
    const ancestorDialog = modal.parentElement && modal.parentElement.closest('dialog');
    if (ancestorDialog) {
      originalPosition.set(modal, { parent: modal.parentElement, next: modal.nextSibling });
      document.body.appendChild(modal);
    }

    if (typeof modal.showModal === 'function') {
      try {
        modal.showModal();
      } catch (_) {
        modal.setAttribute('open', '');
      }
    } else {
      modal.setAttribute('open', '');
    }
    document.body.classList.add('size-guide-modal-open');
  };

  const restorePosition = (modal) => {
    const pos = originalPosition.get(modal);
    if (!pos) return;
    originalPosition.delete(modal);
    if (pos.next && pos.next.parentNode === pos.parent) {
      pos.parent.insertBefore(modal, pos.next);
    } else {
      pos.parent.appendChild(modal);
    }
  };

  const closeModal = (modal) => {
    if (!modal) return;
    if (typeof modal.close === 'function') {
      try {
        modal.close();
      } catch (_) {
        modal.removeAttribute('open');
      }
    } else {
      modal.removeAttribute('open');
    }
    document.body.classList.remove('size-guide-modal-open');
  };

  const findModal = (trigger, targetId) => {
    const scope = trigger.closest('quick-add-dialog, dialog, [data-product-grid-content]');
    if (scope) {
      const scoped = scope.querySelector(`#${CSS.escape(targetId)}`);
      if (scoped) return scoped;
    }
    return document.getElementById(targetId);
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const trigger = target.closest('[data-size-guide-target]');
    if (trigger) {
      event.preventDefault();
      const targetId = trigger.getAttribute('data-size-guide-target');
      if (targetId) openModal(findModal(trigger, targetId));
      return;
    }

    const closeBtn = target.closest('[data-size-guide-close]');
    if (closeBtn) {
      event.preventDefault();
      closeModal(closeBtn.closest('.size-guide-modal'));
      return;
    }

    if (target.tagName === 'DIALOG' && target.classList.contains('size-guide-modal')) {
      closeModal(target);
    }
  });

  // 'close' fires for every close path (Escape/cancel, .close(), backdrop click)
  // and — like 'cancel' — does not bubble, so it must be caught in the capture phase.
  document.addEventListener(
    'close',
    (event) => {
      const t = event.target;
      if (t instanceof HTMLDialogElement && t.classList.contains('size-guide-modal')) {
        document.body.classList.remove('size-guide-modal-open');
        restorePosition(t);
      }
    },
    true
  );
})();
